export const FIRMOGRAPHIC_TOOLTIP = 'Our standard dataset typically' +
    ' includes a number of different firmographics.';
